import { useState } from 'react';

import { Modal } from '../../../../components/modal';
import { useMerchant } from '../../../../hooks/useMerchant';
import { CustomLink } from '../../../../models/payment-links-custom';
import {
	LinkCopyPasteContainer,
	ModalContainer,
	QRCodeImgContainer,
	QRContainer,
	QRContainerData,
	QRSubtitle,
	QRSubtitleBottom,
	QRTitle,
} from './styles';

interface ShareLinkModal {
	show: boolean;
	onClose: () => void;
	data: CustomLink;
}

const ShareLinkModal = ({ show, onClose, data }: ShareLinkModal) => {
	const { merchantSelected } = useMerchant();
	const [copied, setCopied] = useState('Copiar');
	const urlArray = data.token_url.split('//');

	const _copyCliboard = async () => {
		await navigator.clipboard.writeText(data.token_url);
		setCopied('Copiado');
		setTimeout(() => setCopied('Copiar'), 2500);
	};

	const renderAmount = () => {
		if (data.amounttype === 'VARIABLE') {
			return (
				<QRTitle>
					Pagar {data.orderamountmin} - {data.orderamountmax}
				</QRTitle>
			);
		} else {
			return <QRTitle>Pagar {data.amount}</QRTitle>;
		}
	};
	return (
		<Modal title="Compartir enlace" show={show} onClose={onClose} type="medium">
			<ModalContainer>
				<LinkCopyPasteContainer>
					<small>Enlace de cobro</small>
					<QRContainerData>
						<span>{urlArray[1]}</span>
						<button type="button" onClick={_copyCliboard}>
							{copied}
						</button>
					</QRContainerData>
				</LinkCopyPasteContainer>
				<QRContainer>
					{renderAmount()}
					<QRSubtitle>{data.name}</QRSubtitle>
					<QRCodeImgContainer>
						<img src={data.token_qr} alt="QR del pago" />
					</QRCodeImgContainer>
					<QRSubtitleBottom>
						Escanea el código <br /> para pagar a {merchantSelected?.name}
					</QRSubtitleBottom>
				</QRContainer>
			</ModalContainer>
		</Modal>
	);
};

export { ShareLinkModal };
